import { MatDialog } from '@angular/material/dialog';
import { LogService } from '@pershing/pershing-core';
import { ALERT_MESSAGE_LEVEL } from '../../../utils/trading-constants';
import { AlertMessageDialogComponent } from './alert-message-dialog.component';

export function openAlertMessageDialog(msgHeader: string, msgBody: string, confirmButton: string, cancelButton: string, level: ALERT_MESSAGE_LEVEL,
                                        dialog: MatDialog, logService: LogService) {
    const alertMessageDialogRef = dialog.open(AlertMessageDialogComponent, {
        panelClass: 'modal',
        disableClose: true,
        autoFocus: false,
        data: {
            msgHeaderLabel: msgHeader,
            msgBodyLabel: msgBody,
            msgLevel: level,
            confirmButtonLabel: confirmButton,
            cancelButtonLabel: cancelButton
        }
    });

    alertMessageDialogRef.afterClosed().subscribe((data) => {
        logService.log('The openAlertMessageDialogRef was closed', data);
    });
}
